import { useSelector } from 'react-redux';
import styles from './styles.module.css';

export default function Jumbotron() {
    const strapiData:any = useSelector<any>(state=>state.strapi?.entireStrapiData?.WebappHomepageV22?.WebappHomepageV22);
    const strapiData2:any = useSelector<any>(state=>state.strapi?.entireStrapiData?.StaggeredListItemType?.StaggeredListItemType);

    return <div className={styles.jumbotron}>
        {/* <div className={styles.mainHeading}>
            <div className={styles.line1}>{strapiData?.DesignStudioTitle || "Suited for Solopreneurs"}</div>
            <div className={styles.free}>{strapiData2?.FreeText || "FREE"}</div>
        </div> */}

        <div className={styles.line2}>{strapiData?.DesignStudioDescription || "Looking to create your eCommerce content?"}</div>
    </div>
}